"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAuthorRecentsItemKey_LatestDevDraftRuntimeDescriptorForProject = void 0;
const assert_args_present_1 = require("../utils/assert-args-present");
var AuthorRecentsItemKeyPrefix;
(function (AuthorRecentsItemKeyPrefix) {
    AuthorRecentsItemKeyPrefix["LatestDevDraftRuntimeDescriptorForProject"] = "LatestDevDraftRuntimeDescriptorForProject";
    // LatestExamSuiteOutput = 'LatestExamSuiteOutput',
})(AuthorRecentsItemKeyPrefix || (AuthorRecentsItemKeyPrefix = {}));
function buildAuthorRecentsItemKey_LatestDevDraftRuntimeDescriptorForProject(automationProjectUid) {
    assert_args_present_1.assertRequiredArgsDefined({ automationProjectUid });
    return `${AuthorRecentsItemKeyPrefix.LatestDevDraftRuntimeDescriptorForProject}:${automationProjectUid}`;
}
exports.buildAuthorRecentsItemKey_LatestDevDraftRuntimeDescriptorForProject = buildAuthorRecentsItemKey_LatestDevDraftRuntimeDescriptorForProject;
// tmp - tbd. Needed? Can use LatestDevDraftRuntimeDescriptorForProject to also fetch exam output
// export function buildAuthorRecentsItemKey_LatestExamSuiteOutput(examSuiteUid: ExamSuiteUid): string {
//   requireUid(examSuiteUid, 'examSuiteUid');
//   return `${AuthorRecentsItemKeyPrefix.LatestExamSuiteOutput}:${examSuiteUid}`;
// }
//
// export function buildAuthorDraftItemKeyForNestedAutomation(): string {
//
// }
//# sourceMappingURL=author-recents-item-keys.js.map